function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useMemo } from 'react';
import useSWR, { cache } from 'swr';
import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { ALLOY_KEY_PREFIX, baseParser, setDataInStorage } from './commonCache';
export var clearNetworkCache = function clearNetworkCache() {
  cache.clear();
  Object.keys(sessionStorage).filter(function (k) {
    return k.startsWith(ALLOY_KEY_PREFIX);
  }).forEach(function (k) {
    return sessionStorage.removeItem(k);
  });
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var defaultConfig = {
  fetcher: fetchWithToken,
  revalidateOnFocus: false,
  shouldRetryOnError: false,
  revalidateOnMount: true,
  onSuccess: setDataInStorage
};

var alloyPrefix = function alloyPrefix(str) {
  return "".concat(ALLOY_KEY_PREFIX).concat(str);
};

export var useSWRAlloy = function useSWRAlloy(key) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fetchWithToken;
  var config = arguments.length > 2 ? arguments[2] : undefined;

  var _cache$serializeKey = cache.serializeKey(key),
      _cache$serializeKey2 = _slicedToArray(_cache$serializeKey, 1),
      cacheKey = _cache$serializeKey2[0];

  var initialData = useMemo(function () {
    return baseParser(sessionStorage.getItem(alloyPrefix(cacheKey)));
  }, [cacheKey]);
  var finalConfig = useMemo(function () {
    return _objectSpread(_objectSpread({
      initialData: initialData
    }, defaultConfig), config);
  }, [config, initialData]);
  var res = useSWR(key, fn, finalConfig);
  var originalMutate = res.mutate; // This mutate wrapper saves the data to local storage.
  // We need it because `onSuccess` isn't called when calling mutate with shouldRevalidate=false

  var mutateWrapper = useCallback(function (data, shouldRevalidate) {
    var mutateRes = originalMutate(data, shouldRevalidate);

    if (!shouldRevalidate) {
      setDataInStorage(data, cacheKey);
    }

    return mutateRes;
  }, [cacheKey, originalMutate]);

  var clearSessionStorage = function clearSessionStorage() {
    sessionStorage.removeItem("".concat(ALLOY_KEY_PREFIX).concat(key));
  };

  return _objectSpread(_objectSpread({}, res), {}, {
    clearSessionStorage: clearSessionStorage,
    mutate: mutateWrapper
  });
};
//# sourceMappingURL=cache.js.map